import { ReportInterface } from '../../../interfaces/report.interface';

export class SetReport {
    public static readonly type = '[JobsPlacements] set report';

    constructor(public report: ReportInterface) {}
}
